
//export  const appURL = "http://localhost:3000";
export  const appURL = "https://nestor-surf-wally.web.app";
export  const cloudRunBaseURL = "https://backend-nestorsurf-wally.fly.dev/";
//export  const baseURL = "http://localhost:8080";
export  const baseURL = "https://backend-nestorsurf-wally.fly.dev";
//export  const phpURL = "http://localhost:8888/wallyglisse/_MAJ_2024/";
export  const phpURL = "https://wallyglisse.com/";
